import { SITE_NAME } from "@/helper/constant";
import { t, localePrefix } from "@/helper/helper";
import { pages } from "@/services/requests";
import "bootstrap/dist/css/bootstrap.min.css";
import { IFaq } from "global-types/global.types";
import { GetServerSideProps } from "next";
import Head from "next/head";
import Link from "next/link";
import { useId } from "react";
import Accordion from "react-bootstrap/Accordion";
import styled from "styled-components";

interface Props {
  data: IFaq;
  locale: string;
}

export default function Faq({ locale, data }: Props) {
  const faqId = useId();

  return (
    <Wrapper>
      <Head>
        <title>{SITE_NAME} Faq</title>
      </Head>
      <div className="faq">
        <div className="faq__container">
          <div
            className="about-header"
            style={{
              backgroundImage: `url(https://api.promusic.az/uploads/aboutus/vgidxGWsioLcOPiVg6g6bGSi7OBaqiaH4lmqr3Jk5LBkriGDUEBFb9dWjxCg3QtL.jpg)`,
            }}
          >
            <div className="breadcrumb">
              <Link href={`${localePrefix(locale) || "/"}`}>{t("homePage", locale)}</Link>
              <span className="breadcrumb-seperator" />
              <Link href={`${localePrefix(locale)}/contact`}>{t("contact", locale)}</Link>
            </div>
          </div>
          <H1>{t("faq", locale)}</H1>
          {data.data.map((item, index) => (
            <Accordion>
              <Accordion.Item
                eventKey={item.sort.toString()}
                key={faqId + index}
              >
                <Accordion.Header>{item.question}</Accordion.Header>
                <Accordion.Body>{item.answer}</Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
        </div>
      </div>
    </Wrapper>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  try {
    const { locale } = ctx;

    const data = await pages.getFaq(locale);

    return {
      props: {
        locale,
        data,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const H1 = styled.h1`
  font-size: 30px;
  margin-bottom: 30px;
  font-weight: bold;
`;

const Wrapper = styled.div`
  .faq {
    &__container {
      width: 1128px;
      margin: 0 auto;
      padding: 4rem 0;

      .accordion {
        margin-bottom: 20px;

        button {
          color: #222 !important;
          background-color: transparent !important;
          box-shadow: none !important;
        }
      }

      @media screen and (max-width: 1199px) {
        width: 100%;
        padding: 0 16px;
      }
    }

    .accordion-header {
      button {
        font-size: 20px;
      }
    }

    .accordion-body {
      font-size: 16px;
    }

    .about-header {
      // background: url("../../assets//img/account-bg.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      width: 100%;
      height: 27rem;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      padding: 2.4rem;
      margin-bottom: 5.6rem;
      margin-top: 24px;

      .breadcrumb {
        padding-top: 0;
        display: block;

        a {
          color: #fff;
        }

        .breadcrumb-seperator {
          background-color: #fff;
        }
      }
    }
  }
`;
